import { Checkbox, Modal, ModalClose, ModalDialog } from '@mui/joy';

import { useState } from 'react';

import { Button, Text } from '@/design-system';

export const EvaluatorConfirmationModal = ({
  isConfirmationModalOpen,
  setIsConfirmationModalOpen,
  setDontShowConfirmationAgain,
  onSaveAndContinue,
  isSaving,
  proceed,
}: {
  proceed?: () => void;
  isConfirmationModalOpen: boolean;
  setIsConfirmationModalOpen: (value: boolean) => void;
  setDontShowConfirmationAgain: (value: boolean) => void;
  onSaveAndContinue: () => Promise<void>;
  isSaving: boolean;
}) => {
  const [isDontShowAgainChecked, setIsDontShowAgainChecked] = useState(false);
  return (
    <Modal
      open={isConfirmationModalOpen}
      onClose={() => setIsConfirmationModalOpen(false)}
    >
      <ModalDialog>
        {!isSaving && <ModalClose />}
        <div className="flex max-w-[500px] flex-col gap-5">
          <Text variant="h2" className="text-lg font-semibold">
            Unsaved Changes
          </Text>
          <div className="flex flex-col gap-3">
            <Text variant="body" className="text-tertiary">
              Your evaluator has unsaved changes that will be lost if you
              continue. Save your evaluator to preserve your changes.
            </Text>
            <div className="flex items-center gap-3">
              <Checkbox
                checked={isDontShowAgainChecked}
                onChange={() => setIsDontShowAgainChecked((prev) => !prev)}
              />
              <Text variant="body" className="text-quaternary">
                Don't show this message again
              </Text>
            </div>
          </div>
          <div className="flex gap-2 self-end">
            <Button
              variant="plain"
              color="secondary"
              onClick={() => {
                setIsConfirmationModalOpen(false);
              }}
              disabled={isSaving}
            >
              Cancel
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                if (isDontShowAgainChecked) {
                  setDontShowConfirmationAgain(true);
                }
                proceed?.();
              }}
              disabled={isSaving}
            >
              Continue Without Saving
            </Button>
            <Button
              color="primary"
              onClick={onSaveAndContinue}
              loading={isSaving}
              disabled={isSaving}
            >
              Save and Continue
            </Button>
          </div>
        </div>
      </ModalDialog>
    </Modal>
  );
};
